import ContinueButton from '@/components/continue-button/continue-button';
import TermsAndPrivacy from '@/components/terms-and-privacy/TermsAndPrivacy';
import validationService from '@/services/validation.service';
import { FormControl, FormErrorMessage } from '@chakra-ui/react';
import { Box, Flex, InlineAlert, Input, Text } from '@cmpsr/components';
import useSignUpController from './sign-up.controller';
import { SignUpStepper } from './components/SignUpStepper';
import { VARS } from '../ppra/components/common/constants';

export default function SignUpPage() {
  const { form, handleSubmit } = useSignUpController();

  return (
    <Box backgroundColor={'white'} minHeight="100vh">
      <Flex
        direction="column"
        alignItems="center"
        justifyContent="center"
        py={{ base: '1.25rem', lg: '2rem' }}
        gap={{ base: '1.25rem', lg: '1.75rem' }}
        margin="0 auto"
        width="100%"
        maxWidth="33rem"
      >
        <Box width="100%" mb={{ base: '6', md: '10' }}>
          <SignUpStepper activeStep={0} activeFilled={false} />
        </Box>

        <Flex direction="column" alignItems="center" gap={4} textAlign="center" px={{ base: '6', md: '0' }}>
          <Text
            textAlign="center"
            fontSize={{ base: '1.875rem', lg: '3.125rem' }}
            fontWeight="bold"
            lineHeight={{ base: '101%', lg: '111%' }}
            fontStyle="normal"
          >
            Know your risk{' '}
            <Text
              as="span"
              fontWeight={{ base: 200, lg: 400 }}
              fontSize={{ base: '1.875rem', lg: '3.125rem' }}
              fontStyle={{ base: 'italic', lg: 'normal' }}
            >
              and take control
            </Text>
          </Text>
          <Text color="text.subtle" maxW="25rem" fontSize="1.25rem" fontWeight="400" lineHeight="130%">
            500+ risk factors, 21 major cancers, mapped to you for just {VARS.price.yearly}
          </Text>
        </Flex>

        <Box
          as="form"
          onSubmit={handleSubmit}
          width="100%"
          backgroundColor="#F0F5F6"
          borderRadius="lg"
          p={{ base: '2.5rem', md: '1.69rem' }}
        >
          <Flex gap={{ base: 4, md: 6 }} backgroundColor="#F0F5F6" flexDirection="column" alignItems="center">
            <Text variant="text-body-large-bold">What's your email address?</Text>
            <FormControl id="email" isInvalid={!!form.formState.errors.email}>
              <Input
                id="email"
                aria-label="Email"
                variant="outline"
                size="l"
                placeholder={'Enter email address'}
                isInvalid={!!form.formState.errors.email}
                autoFocus
                {...form.register('email', {
                  required: 'Please type an email address',
                  validate: (v: string) => {
                    const isValid = validationService.validateEmail(v);
                    return isValid || 'Please provide a valid email address';
                  },
                })}
                borderColor="neutral.border"
                _hover={{
                  borderColor: 'neutral.border-hover',
                }}
                _focus={{
                  borderColor: 'primary.500',
                  boxShadow: `0 0 0 1px var(--cmpsr-colors-primary-500)`,
                }}
              />
              {form.formState.errors.email?.message && (
                <FormErrorMessage mt="spacer-2">
                  <InlineAlert status="error">
                    <InlineAlert.Icon />
                    <InlineAlert.Message>{form.formState.errors.email.message}</InlineAlert.Message>
                  </InlineAlert>
                </FormErrorMessage>
              )}
            </FormControl>
            <ContinueButton
              isDisabled={!!form.formState.errors.email || form.formState.isSubmitting}
              isLoading={form.formState.isSubmitting}
              width="100%"
              size="l"
            />
            <TermsAndPrivacy buttonMessage="Continue" />
          </Flex>
        </Box>
      </Flex>
    </Box>
  );
}
